import React from 'react';
export function VulnerabilityDisclosure() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-12099" data-mp="3im8jow9ldf50">
      <h1 className="text-4xl font-bold text-[#2B211A] mb-8 font-title tracking-tight" data-id="element-12100" data-mp="1nxjv9n39ahzz">
        Vulnerability Disclosure Policy
      </h1>

      <div className="space-y-8 text-neutral-600 font-body leading-relaxed" data-id="element-12101" data-mp="1rxu2t46p5ggy">
        <section data-id="element-12102" data-mp="1wxq4uxvu2xtv">
          <p className="text-lg text-neutral-700" data-id="element-12103" data-mp="1wy8a2k0h4mdx">
            Giga, operated by Tonic Labs Limited, is committed to the security of
            our systems and our users&apos; data. We value the work of security
            researchers, and this policy explains which systems are in scope, how
            to conduct testing safely, and how to report a vulnerability to us.
          </p>
        </section>

        <section data-id="element-12104" data-mp="1e28i397hxiuc">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12105" data-mp="gkrlu80oqow9">
            1. Guidelines
          </h2>
          <p className="mb-4" data-id="element-12106" data-mp="lit5ov5xqs8s">We ask that you:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-12107" data-mp="lhi1wvchpkho">
            <li data-id="element-12108" data-mp="r5oes6wolfm7">Notify us as soon as possible after you discover a real or potential security issue.</li>
            <li data-id="element-12109" data-mp="n5wdmf9mabqv">Give us a reasonable amount of time to resolve the issue before disclosing it publicly.</li>
            <li data-id="element-12110" data-mp="ictgxy9jmm6g">
              Make every effort to avoid privacy violations, degradation of the
              user experience, disruption to production systems, and the
              destruction or manipulation of data.
            </li>
            <li data-id="element-12111" data-mp="3hdlppx88k8h">
              Only use exploits to the extent necessary to confirm a
              vulnerability. Do not use an exploit to exfiltrate data, establish
              persistence, or pivot to other systems.
            </li>
            <li data-id="element-12112" data-mp="3qn4pmihnyhdo">
              If you encounter any sensitive data (personal, financial, or
              proprietary), stop your test, notify us immediately, and keep the
              data strictly confidential.
            </li>
            <li data-id="element-12113" data-mp="1osnden6xoxmq">Do not submit a high volume of low-quality reports.</li>
          </ul>
        </section>

        <section data-id="element-12114" data-mp="27x8pqvo2jspx">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12115" data-mp="2cq1tphbpqx0y">
            2. Authorization &amp; Safe Harbour
          </h2>
          <p className="mb-4" data-id="element-12116" data-mp="1z08612by2ist">
            Security research carried out in good faith and in accordance with
            this policy is considered authorised. We will work with you to
            understand and resolve the issue quickly, and Tonic Labs Limited will
            not recommend or pursue legal action in connection with your research.
          </p>
        </section>

        <section data-id="element-12117" data-mp="2ho3dy5kvl2e0">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12118" data-mp="2homx1pm9hwtm">
            3. Scope
          </h2>
          <p className="mb-4" data-id="element-12119" data-mp="169zisw2jx87d">This policy applies to the following systems and services:</p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-12120" data-mp="16cc8jvejwmuz">
            <li data-id="element-12121" data-mp="1b9voczqwd7p1">The Giga marketing website (<code data-id="element-12122" data-mp="1b6zq1ab50h02">getgiga.com</code>)</li>
            <li data-id="element-12123" data-mp="13p1ru1yeosc5">The Giga web application (<code data-id="element-12124" data-mp="13o8nf7mx6ex6">app.getgiga.com</code>)</li>
            <li data-id="element-12125" data-mp="yqgse4qzacor">Giga&apos;s integrations with Google Workspace and Slack</li>
          </ul>
          <p className="mb-4" data-id="element-12126" data-mp="yst625ppe0w0">
            Any service not explicitly listed above is out of scope and must not
            be tested. Vulnerabilities in third-party services Giga integrates
            with are not covered by this policy and should be reported directly to
            the relevant vendor. If you are unsure whether a system is in scope,
            email us at{' '}
            <a href="mailto:security@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-12127" data-mp="fxw4l1q4yxrt">
              security@getgiga.com
            </a>{' '}
            before you begin.
          </p>
        </section>

        <section data-id="element-12128" data-mp="1b2x2imuywa6">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12129" data-mp="1akqas2kkzo0">
            4. Testing That Is Not Authorised
          </h2>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-12130" data-mp="3sfb3tijonhqz">
            <li data-id="element-12131" data-mp="9zrpujrsmk4g">Network denial-of-service (DoS or DDoS) testing.</li>
            <li data-id="element-12132" data-mp="exjt29xw1sny">
              Physical testing (e.g. office access, tailgating), social
              engineering (e.g. phishing, vishing), and any other non-technical
              testing.
            </li>
          </ul>
        </section>

        <section data-id="element-12133" data-mp="ooegviqs90bi">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12134" data-mp="ooxp27qmsacc">
            5. Reporting a Vulnerability
          </h2>
          <p className="mb-4" data-id="element-12135" data-mp="xnrpk9731kv6">
            To report a security issue, email{' '}
            <a href="mailto:security@getgiga.com" className="text-[#EA580C] hover:underline font-medium" data-id="element-12136" data-mp="12nnlrm9jg806">
              security@getgiga.com
            </a>
            . Reports may be submitted anonymously. To help us triage and respond,
            please include where possible:
          </p>
          <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-12137" data-mp="39dkc8am6tpo2">
            <li data-id="element-12138" data-mp="39edjdcp26h6q">A description of the vulnerability.</li>
            <li data-id="element-12139" data-mp="1qj96px95n9lp">Where it was discovered (URL, endpoint, or component).</li>
            <li data-id="element-12140" data-mp="1ls0tsr8m963s">The potential impact.</li>
            <li data-id="element-12141" data-mp="1lqy3olj4b7ox">Steps to reproduce it (scripts and screenshots are helpful).</li>
          </ul>
          <p className="mb-4" data-id="element-12142" data-mp="1hrgxtqzs48j8">If possible, please provide your report in English.</p>
        </section>

        <section data-id="element-12143" data-mp="1csdqfzwbtq83">
          <h2 className="text-2xl font-semibold text-[#2B211A] mb-4 font-title tracking-tight" data-id="element-12144" data-mp="1csvyruw9juwd">
            6. Our Commitment
          </h2>
          <p className="mb-4" data-id="element-12145" data-mp="25g04k236kd97">
            We will acknowledge receipt of your report within three business days.
            If you provide contact details, we will keep you informed of our
            progress on confirming and remediating the issue to the best of our
            ability, and we welcome a dialogue about your findings.
          </p>
        </section>

        <section className="pt-8 border-t border-neutral-200/60" data-id="element-12146" data-mp="p31if3cqjo7d">
          <p className="text-sm text-neutral-500" data-id="element-12147" data-mp="k1lxdbak5hoz">Last updated: July 2026</p>
          <p className="text-sm text-neutral-500 mt-1" data-id="element-12148" data-mp="ljaxugz68kqf">
            © 2026 Tonic Labs Limited. All rights reserved.
          </p>
        </section>
      </div>
    </div>;
}